
import LpInput from "@/app/ui/components/lp-input/index.vue";
import { Options, Vue, prop } from "vue-class-component";
import { TicketListItem } from "@/domain/entities/PusatResolusiV2";

class Props {
  modelValue = prop<boolean>({
    type: Boolean,
    default: false
  });
  tickets = prop<Array<TicketListItem>>({
    default: [],
    type: Array
  });
}

@Options({
  emits: ["update:modelValue", "onCheckIssue", "ticket-select"],
  components: {}
})
export default class ModalCheckIssue extends Vue.with(Props) {
  sttNumber = "";

  get isCheckDisable() {
    return !this.sttNumber;
  }

  set openDialog(value: boolean) {
    this.$emit("update:modelValue", value);
  }

  get openDialog() {
    return this.modelValue;
  }

  cancelPopup() {
    this.sttNumber = "";
    this.$emit("update:modelValue");
  }

  onCheckIssue() {
    this.$emit("onCheckIssue", this.sttNumber);
  }

  ticketSelect(id: number) {
    this.$emit("ticket-select", id);
  }

  onChangeSttNumber(value: string) {
    this.sttNumber = value;
  }

  formatRefNumber(value: string) {
    return value.toUpperCase().replace(/\s+/g, "");
  }

  mapStatusTicket(status: string): any {
    const statusLabel: any = () => {
      const obj = {
        NEW: this.$t('pusatResolusi.new'),
        WORKING: this.$t('pusatResolusi.inProcess2'),
        ESCALATED: this.$t('pusatResolusi.inEscalation'),
        "ON HOLD": this.$t('pusatResolusi.onHold'),
        SOLVED: this.$t('pusatResolusi.solved'),
        CLOSED: this.$t('pusatResolusi.closed')
      } as any;
      return obj[status] ?? status;
    };
    const style: any = () => {
      const obj = {
        NEW: "bg-blue-lp-200 text-blue-lp-300",
        WORKING: "bg-yellow-lp-200 text-yellow-lp-100",
        ESCALATED: "bg-purple-lp-100 text-purple-lp-800",
        "ON HOLD": "bg-gray-lp-200 text-gray-lp-300",
        SOLVED: "bg-green-lp-300 text-green-lp-400",
        CLOSED: "bg-chocolate-lp-200 text-chocolate-lp-100"
      } as any;
      return obj[status] ?? "bg-gray-lp-200 text-gray-lp-300";
    };
    return {
      label: statusLabel(),
      style: style()
    };
  }
}
